import * as kitTypesService from '../../../services/KitTypes/kitTypesService.js';
import * as daHelper from '../dialogActionsHelper';
import {dialogsNames} from '../../../enums/dialogsNames';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';

const config = {
  getSubmitMethod: (submitConfigData) => {
    return submitConfigData?.isMultiKitTypes ?
      kitTypesService.updateWorkOrdersMultiKitTypesVersions : kitTypesService.updateWorkOrdersKitTypeVersion;
  },
  onNotValidResponse: (response) => {
    if (response?.status !== 304) {
      return null;
    }
    const labels = createLabelHelper('mat.administration.matsettings.dialog.updatekitTypeVersion.');
    return {
      title: labels.get('schedulerRunning'),
      className: 'oneBackground',
      type: 'warning',
    };
  },
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.UPDATE_KIT_TYPE_VERSION_DIALOG),
};

const actions = {
  ...daHelper.getActions(dialogsNames.UPDATE_KIT_TYPE_VERSION_DIALOG),

};

export let api = {
  ...daHelper.getApiActions(actions, config),
}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

};
